export default "__VITE_ASSET__DOTgitp___"